import 'isomorphic-fetch'

import { artistEndpoint } from '~apiConfig'
import { getApiResponseInJSON, getIdToken } from '~utils'

import { FETCH_ARTISTS } from '../actionTypes'

export const fetchArtistsList = params => async dispatch => {
  const { method, url } = artistEndpoint.list
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    body: JSON.stringify(params),
    headers: {
      Authorization: `Bearer ${idToken}`
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => console.error(error))
  const { artists: rows, artistsCount: rowsCount } = apiResponse
  dispatch({
    type: FETCH_ARTISTS,
    payload: {
      rows,
      rowsCount,
      params
    }
  })
}
